import angular from 'angular';

import LoaderModule from './loader';
import LogoModule from './logo';
import ImageModule from './image';
import PlansModule from './plans';

export default angular
    .module('common.component', [
        LoaderModule.name,
        LogoModule.name,
        ImageModule.name,
        PlansModule.name
    ]);



// WEBPACK FOOTER //
// ./src/common/component/index.js